import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './changePassword.css'
import { Card, Button, Form, Input } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import LoadingOverlay from '../loadingOverlay/loadingOverlay';

import { apiUrl } from '../../utility/Connections';

const ChangePassword = () => {

    const [form] = Form.useForm();

    const [showLoading, setShowLoading] = useState(false)
    const [loadingText, setLoadingText] = useState(null)
    const [newPassErrorText, setNewPassErrorText] = useState(null)

    const onFinish = async (values) => {
        setNewPassErrorText(null)
        
        if (values.new_password != values.new_password_validate) {
            setNewPassErrorText("Las contraseñas no coinciden")
        } else {
            setShowLoading(true);
            setLoadingText("Cambiando contraseña...");
            const formData = new FormData();
            formData.append('current_password', values.current_password);
            formData.append('new_password', values.new_password);
    
            const token = localStorage.getItem('access_token');
            
            const headers = {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            }
    
            await axios
                .put(`${apiUrl}/users/change-password/`, formData, headers)
                .then(function (response) {
                    setShowLoading(false);
                    setLoadingText(null);
                    showSwal(response.data.message, 2, "Correcto");
                    setNewPassErrorText(null);
                    form.resetFields();
                })
                .catch(function (error) {
                    setShowLoading(false);
                    setLoadingText(null);
                    console.error(error)
                    setNewPassErrorText(null);
                    showSwal(error.response.data.message, 0, "Atención");
                });
        }

    };
    const onFinishFailed = (errorInfo) => {
        console.error('Failed:', errorInfo);
    };

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    return <>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Card>
            <Form
                form={form} 
                name="normal_login"
                className="login-form"
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                <Form.Item
                    name="current_password"
                    rules={[
                        {
                            required: true,
                            message: 'Por favor ingrese la contraseña actual',
                        },
                    ]}
                >
                    <Input.Password
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        placeholder="Contraseña actual"
                    />
                </Form.Item>
                <Form.Item
                    name="new_password"
                    rules={[
                        {
                            required: true,
                            message: 'Por favor ingrese la nueva contraseña',
                        },
                    ]}
                >
                    <Input.Password
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        placeholder="Nueva contraseña"
                    />
                </Form.Item>
                <Form.Item
                    name="new_password_validate"
                    rules={[
                        {
                            required: true,
                            message: 'Por favor ingrese la nueva contraseña nuevamente',
                        },
                    ]}
                >
                    <Input.Password
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        placeholder="Nueva contraseña nuevamente"
                    />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                        Cambiar contraseña
                    </Button>
                </Form.Item>
            </Form>
            {
                newPassErrorText && <span className='login-error-text'>{newPassErrorText}</span>
            }
        </Card>
    </>
}

export default ChangePassword;





